<template>
  <section class="togglable-section">
    <header-with-toggle
      v-bind:title="title"
      v-bind:expanded="expanded"
      v-on:toggle="expanded = !expanded"
    />
    <ul v-if="expanded" class="list-group">
      <slot></slot>
    </ul>
  </section>
</template>

<script>
import HeaderWithToggle from '@/components/utilities/header-with-toggle';

export default {
  name: 'togglable-section',
  props: ['title'],
  components: {
    'header-with-toggle': HeaderWithToggle,
  },
  data: function () {
    return {
      expanded: true,
    };
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/togglable-section.vue